import { history } from '@@/core/history';
import { notification } from 'antd';
import ENV, { EnvPlatform, EnvVersion } from '@/conf/env';
import { EnvBase } from '@/conf/env.config';

export const requestHeaders = () => {
  let headers = {};
  for (const key in ENV.keys) {
    let value: string = ENV.keys[key] || '';
    if (value == '') {
      continue;
    }
    headers[EnvBase.headerPre + value.toUpperCase()] =
      localStorage.getItem(EnvBase.storageHeaderPre + value.toUpperCase()) || '';
  }

  headers[EnvBase.headerPre + 'PLATFORM'] = EnvPlatform.trim().toUpperCase();
  headers[EnvBase.headerPre + 'version'] = EnvVersion;
  if (ENV.channel) {
    headers[EnvBase.headerPre + 'CHANNEL'] = ENV.channel;
  }
  return headers;
};

/**
 * 请求拦截
 * @param url
 * @param options
 */
export const requestInterceptor = (url: any, options: any): any => {
  // console.log('Request interceptor: options', url, options);
  let headers = {
    ...options.headers,
  };
  if (options.baseURL == ENV.baseURL) {
    headers = {
      ...headers,
      ...requestHeaders(),
    };
  }

  return {
    url: url,
    options: { ...options, headers: headers },
  };
};

function loginTimeout(message: string) {
  notification.open({
    key: 'timeout',
    type: 'error',
    message: '提示',
    description: message,
  });
  // localStorage.removeItem(ENV.storage_org_key);
  // localStorage.removeItem(ENV.storage_auth_key);
  // localStorage.removeItem(ENV.storage_store_key);
  history.push('/login');
}

/**
 * 响应拦截
 * @param response
 */
export const responseInterceptors = (response: any): any => {
  const options = response.config;
  const { status, data } = response ?? {};
  const headerPre = EnvBase.headerPre || '';
  if (headerPre != '' && Object.keys(response.headers).length > 0) {
    let len = headerPre.length;
    Object.keys(response.headers).forEach((k) => {
      if (!k.toLowerCase().startsWith(headerPre.toLowerCase())) {
        return;
      }
      let headerKey = k.slice(len);
      localStorage.setItem(EnvBase.storageHeaderPre + headerKey.toUpperCase(), response.headers[k]);
    });
  }

  if (status === 200) {
    if ([10401, 10403].includes(data.code)) {
      loginTimeout(data?.message);
    }
  } else {
    switch (status) {
      case 401:
      case 403:
        loginTimeout(data?.message);
        break;
    }
  }
  if (['blob', 'arraybuffer'].includes((options?.responseType || '').trim().toLowerCase())) {
    return response;
  }
  return data;
};

export const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};

/**
 * 异常处理程序
 * @param error
 * @param opts
 */
export const errorHandler = async (error: any, opts?: any) => {
  const { response } = error;
  if (
    error.response &&
    error.response.data instanceof Blob &&
    error.response.data.type === 'application/json'
  ) {
    let json = undefined;
    try {
      json = await error.response.data.text().then((text) => {
        return JSON.parse(text);
      });
    } catch (e) {
      //
    }
    if (json) {
      response.data = json;
    }
  }
  if (response && response.status) {
    // @ts-ignore
    const errorText = codeMessage[response.status] || response.statusText;
    const { status, data } = response;
    if (status == 401 || [10401, 10403].includes(data.code)) {
      loginTimeout(data?.message);
      return response;
    }
    if (response?.data?.message) {
      if (!(opts?.skipErrorHandler || false)) {
        notification.open({
          type: 'error',
          message: '提示',
          description: response?.data?.message,
        });
      }
    } else {
      if (!(opts?.skipErrorHandler || false)) {
        notification.open({
          type: 'error',
          message: `请求错误 ${status}`,
          description: errorText,
        });
      }
    }
  } else if (!response) {
    notification.open({
      type: 'error',
      description: '您的网络发生异常，无法连接服务器',
      message: '网络异常',
    });
  }
  return response;
};
